<template>
  <div class="cash-history bg-[#23242A] text-white  px-6 pt-1 h-screen pb-52 lg:h-[calc[100vh_-_100px]] overflow-y-auto">
      <div :class="'flex content-main gap-5 ' + (action.component ? ' half-it' : '')">
        <div class="custom-full" v-if="can_view_or_manage_vault">
          <block-loading v-if="loadingBadges"/>
          <template v-else>

            <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]">
              <div class="mb-3 ">
                <div class="text-white px-4 pt-4">
                    <div class="flex justify-between">
                      <input v-model="search" type="text" class="rounded w-full relative pl-9 h-[40px] bg-[#464851] align-top mr-4 border-0" placeholder="Search by Bank Deposit #, Transaction Type, or User" />

                      <div :class="'input-wrapper clearable bg-gray-black h-10 rounded-md mr-2 text-sm'">
                        <Datepicker :inputFormat="'yyyy-MM-dd'" :clearable="true" placeholder="Start Date" :upper-limit="toDate" v-model="fromDate" class="focus:border-transparent focus:ring-0 bg-transparent w-[120px] border-0 h-10"/>
                      </div>

                      <div :class="'input-wrapper clearable bg-gray-black h-10 rounded-md mr-2 text-sm'">
                        <Datepicker :inputFormat="'yyyy-MM-dd'" :clearable="true" placeholder="End Date" :lower-limit="fromDate" v-model="toDate" class="focus:border-transparent focus:ring-0 bg-transparent w-[120px] border-0 h-10"/>
                      </div>
                      <div class="flex flex-row ">
                        <div class="w-[114px] hover:opacity-70 rounded text-center flex justify-center items-center bg-white">
                          <button @click.prevent="openModal('CloseVault')" class="font-normal text-base  leading-5 text-[#2BA66B]">Close Vault</button>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <List :current="true" :selectedCallback="selectedItem" :search="search" :fromDate="fromDate" :toDate="toDate" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/> 
            </div>
          </template>
        </div>
        <restriction-alert v-else/>
    
        <div :class="'w-full hidden-component z-10'" v-if="action.component" >
          <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
        </div>
    </div>
  </div>
  <div>
    <component :is="cashModal.type" v-if="cashModal.popup" @close="closeCreate" :totalBalance="totalBalance" />
  </div>
</template>


<script lang="ts">
import Helpers from '@/helpers';
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import Datepicker from 'vue3-datepicker'
import List from '@/views/CashMgmt/Vault/CashVault/List.vue';
import Add from '@/views/Membership/Program/Badges/Add.vue';
import Update from '@/views/Membership/Program/Badges/Update.vue';
import Nav from "@/views/Membership/Program/Nav.vue";
import AddCash from '@/views/CashMgmt/Vault/CashVault/AddCash.vue'
import ViewCash from '@/views/CashMgmt/Vault/CashVault/ViewCash.vue'
import BankDeposit from '@/views/CashMgmt/Vault/CashVault/BankDeposit.vue'
import CloseVault from '@/views/CashMgmt/Vault/CashVault/CloseVault.vue'
import SafeAudit from '@/views/CashMgmt/Vault/CashVault/SafeAudit.vue'
import ViewSafeAudit from '@/views/CashMgmt/Vault/CashVault/ViewSafeAudit.vue'

export default defineComponent({
  name: "CashVault",
  props: ['totalBalance'],
  components: {
    Nav,
    List,
    Add,
    Update,
    AddCash,
    ViewCash,
    BankDeposit,
    Datepicker,
    CloseVault,
    SafeAudit,
    ViewSafeAudit
  },
  

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    const loyaltyProgram = <any>ref({
      id: null
    });
    const toggleAddDropDown = ref(false)
    const earningSetting = ref({});
    const loadingBadges = ref(false);
    const cashModal = ref({
      popup: false,
      type: ''
    })
    const search = ref('')
    const fromDate = ref(null)
    const toDate = ref(null)
    return {
      action,
      earningSetting,
      loyaltyProgram,
      loadingBadges,
      toggleAddDropDown,
      cashModal,
      search,
      fromDate,
      toDate,
    };
  },

  watch : {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.clearComponent();
    },
  },

  computed: {
    /**
     * View restriction
     */
     can_view_or_manage_vault() {
      return Helpers.getMyPermission('can_view_or_manage_vault')
    },

    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  async mounted() {
    this.emitter.on("reset-badges-component", data => {
      this.clearComponent();
    });
  },

  beforeDestroy() {
    this.emitter.off('reset-badges-component', () => {});
  },
 
  methods: {
    formatDate(date){
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    openModal(type){
      this.cashModal = {
        type: type,
        popup: true
      }
    },
    toggleDropDown(){
      this.toggleAddDropDown = !this.toggleAddDropDown
    },
    closeDropDown(){
      this.toggleAddDropDown = false
    },
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
     if(item.transactionType=='audit' || item.transactionType=='safe audit' || item.transactionType=='float' || item.transactionType=='close vault'){
        this.addUpdate({
          component: 'ViewSafeAudit', 
          data: item
        })
      }else{
        this.addUpdate({
          component: 'ViewCash', 
          data: item
        })
      }
    },

    closeCreate(reload){
      this.cashModal.popup = false
      if(reload){
        this.emitter.emit('refresh-vault-list')
      }
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>
<style>
  .cash-history .v3dp__popout{
    bottom: auto;
  }
</style>


